import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import { showSuccessMsg } from '../../util/messagesUtil';
import buscarTomadores from '../../actions/cteos/tomador/buscarTomadores'
import Tomador from './Tomador';
import ModalCadastrarTomador from './ModalCadastrarTomador';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import excluirTomador from '../../actions/cteos/tomador/excluirTomador';
import PaginacaoTomador from './PaginacaoTomador';
import BotoesPaginacaoTomador from './BotoesPaginacaoTomador';
import determinarPaginaAtualTomadores from '../../actions/cteos/tomador/determinarPaginaAtualTomador';
import alterarRegistrosPorPaginaTomadores from '../../actions/cteos/tomador/alterarRegistrosPorPaginaTomadores';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';

const ModalConfirmacaoExclusaoTomador = ({ tomador, excluir }) => {
    return (<div className="modal fade" id="modalConfirmacaoExclusaoTomador" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoTomador" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir o tomador: <strong>{tomador ? tomador.tipoTomador === 'PF' ? tomador.nomePessoa : tomador.nomeFantasia : ''}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>)
};

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col">Nome</div>
            <div className="col">CNPJ/CPF</div>
            <div className="col-2">Ações</div>
        </div>
    </div>
);


export class PainelGerenciarTomador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tomadorSelecionado: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualTomadores(1)
    }

    componentDidMount() {
        this.buscarTomadores();
    }

    buscarTomadores() {
        this.props.buscarTomadores(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtualTomadores(1);
                this.props.alterarRegistrosPorPaginaTomadores(10);
            }
            this.buscarTomadores();
        }
    }

    selecionarTomador(tomador) {
        this.setState({ tomadorSelecionado: tomador });
    }

    excluirTomador() {
        this.props.excluirTomador(this.state.tomadorSelecionado.id).then(() => {
            showSuccessMsg('Tomador removido com sucesso!');
            this.buscarTomadores();
        });
    }

    exibirBotaoNovoTomador() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-right">
                        <button data-toggle="modal" data-target="#modalCadastrarTomador" className="btn btn-laranja">
                            Novo Tomador
                        </button>
                    </div>
                </div>
            </div>)
    }

    exibirTabelaTomadores() {
        const { tomadores } = this.props
        if (tomadores && tomadores.length) {
            return (<div className="col-12 conteudo-internas">
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoTomador}
                    BotoesPaginacao={BotoesPaginacaoTomador}
                    cupom={tomadores}>
                    <CabecalhoTabela />
                    <div className="lista-table">
                        {this.exibirTomadores()}
                    </div>
                </CabecalhoRodapeTabela>
            </div>
            )
        }
        return <div>Nenhum tomador cadastrado.</div>;
    }

    exibirTomadores() {
        const { tomadores } = this.props
        if (tomadores) {
            return tomadores.map((tomadores, index) => <Tomador key={index} tomador={tomadores}
                selecionarTomador={this.selecionarTomador.bind(this)}
            />)
        }
    }

    render() {
        return (
            <div>
                <div className="row internas">
                    <Titulo texto="Gerenciar Tomadores" urlRetorno="/menu-cteos" />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirBotaoNovoTomador()}
                            {this.exibirTabelaTomadores()}
                            <ModalCadastrarTomador buscarTomadores={this.buscarTomadores.bind(this)} />
                            <ModalConfirmacaoExclusaoTomador tomador={this.state.tomadorSelecionado} excluir={this.excluirTomador.bind(this)} />
                        </div>
                    </Autorizacao>
                </div>
            </div>
        )
    }
}


export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        tomadores: state.tomador.tomadores,
        changeFieldValue,
        paginaAtual: state.tomador.paginaAtualTomadores,
        registrosPorPagina: state.tomador.registrosPorPaginaTomadores,
        filtrosAdicionados: state.filtrosAdicionadosCupom
    }
};


export default connect(mapStateToProps, {
    buscarTomadores,
    excluirTomador,
    determinarPaginaAtualTomadores,
    alterarRegistrosPorPaginaTomadores
})(reduxForm({
    form: 'formularioCadastroCupom'
})(PainelGerenciarTomador))
